<!--
 * @Author: 单译 2694138418@qq.com
 * @Date: 2022-11-26 13:24:25
 * @LastEditors: 单译 2694138418@qq.com
 * @LastEditTime: 2023-01-04 18:28:27
 * @FilePath: \music\src\components\home\newAside.vue
 * @Description: 
 * 
 * Copyright (c) 2022 by 单译 2694138418@qq.com, All Rights Reserved. 
-->
<!--
 * @Author: 单译 2694138418@qq.com
 * @Date: 2022-11-26 13:24:25
 * @LastEditors: 单译 2694138418@qq.com
 * @LastEditTime: 2022-11-28 10:18:28
 * @FilePath: \music\src\components\home\newAside.vue
 * @Description: 
 * 
 * Copyright (c) 2022 by 单译 2694138418@qq.com, All Rights Reserved. 
-->
<template>
    <div class="newAside">
        <el-popover placement="left-end" :open-delay="500" trigger="hover">
            <img :src="$env.VUE_APP_URL + $store.state.service" alt="" class="qrcode"
                style="width: 150px;height:150px">
            <div class="aside_item" slot="reference">
                <img src="../../assets/home/Group 1192 (1).png" alt="">
            </div>
        </el-popover>
        <img   id="newAside" src="../../assets/home/Group 1194 (1).png" alt="" @click="top">
    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    mounted() {
        window.addEventListener("scroll", this.scrollToTop);
    },
    methods: {
        top() {
            // 使用方法
            this.$scrollTo()
        },
        scrollToTop(el) {
            let topBtn = document.getElementById("newAside");
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            let browserHeight = window.outerHeight;
            if (scrollTop > browserHeight - 1000) {
                topBtn.style.display = "block";
            } else {
                topBtn.style.display = "none";
            }
        }
    },
    //离开该页面需要移除这个监听的事件，不然会报错;
    destroyed() {
        window.removeEventListener("scroll", this.scrollToTop);
    }
}
</script>
<style lang="scss" scoped>
.newAside {
    img {
        width: 50px;
        height: 50px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        margin-top: 5px;
    }
    position: fixed;
    left: 50%;
    bottom: 100px;
    margin-left: 636px;
    z-index: 999;
}
#newAside{
    display: none;
}
</style>